// @flow
import Storage from 'local-storage-fallback'

import { CURRENT_REGION_ID as CURRENT_REGION_KEY } from '@src/constants/storageKeys'

export function get(): string {
  return Storage.getItem(CURRENT_REGION_KEY)
}
